import { MultiService } from 'modules/api/MultiService';

export interface IAuthorizeAPIParams {
  authToken: string;
}

export const authorizeAPI = ({ authToken }: IAuthorizeAPIParams) => {
  const service = MultiService.getService();

  service.getAccountingGateway().addToken(authToken);
};
